export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/d50cc34e778c6c20c755dccf4a153599.svg";